/**
 * Converts a string to a deterministic unsigned 32-bit integer.
 * Uses the djb2 algorithm for good distribution.
 */
export const hashString = (str: string): number => {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return hash >>> 0; // Convert to unsigned 32-bit integer
};
